// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2ZMjP","overflowing":"ReadFullNote_overflowing__2nc0i"};